import {fadeIn, fadeOut} from "../../utils/common";
import {collapsedLists, fullList, openNotificationsButton, removeButton, state} from "../index";
import {Api} from "../../api/api";
import {showToast} from "../../toast";
import NotificationFullList from "../notification-full-list/notification-full-list";
import NotificationsState from "../notifications-state/notifications-state";
import {NotificationButton} from "../notification-button/notification-button";
import {NotificationRemoveButton} from "../notification-remove-button";

class NotificationConfirm {
  private backendApi = new Api();
  private readonly element: HTMLElement;
  private state: NotificationsState = state;
  private fullList: NotificationFullList = fullList;
  private collapseList: Map<any, any> = collapsedLists;
  private removeAllButton: NotificationRemoveButton = removeButton;
  private openNotificationsButton: NotificationButton = openNotificationsButton;
  private wrapperElement;
  private confirmButton;
  private closeButton;

  constructor(element) {
    this.element = element;
    this.wrapperElement = this.element.querySelector(`.popup__content`);
    this.confirmButton = this.element.querySelector(`.js-remove-confirm`);
    this.closeButton = this.element.querySelector(`.js-remove-cancel`);

    this.onLayoutClick = this.onLayoutClick.bind(this);
    this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
    this.onConfirmButtonClick = this.onConfirmButtonClick.bind(this);

    this.addEvents();
  }

  showElement() {
    fadeIn(this.element, 200, `flex`);
  }

  hideElement() {
    fadeOut(this.element, 200);
  }

  onWrapperElementClick(evt) {
    evt.stopPropagation();
  }

  onLayoutClick() {
    this.hideElement();
  }

  onCloseButtonClick() {
    this.hideElement();
  }

  onConfirmButtonClick() {
    this.backendApi.customQuery(`/notifications/clear`, {})
      .then((data) => {
        if (data.status === 200) {
          this.state.removeAllNotifications();
          this.fullList.removeAllElements();
          this.collapseList.clear();

          this.removeAllButton.hideButton();

          this.openNotificationsButton.setIsNewStatus();

          this.hideElement();
        } else {
          showToast(`Что-то пошло не так :(`);
        }
      });
  }

  private addEvents() {
    this.wrapperElement.addEventListener(`click`, this.onWrapperElementClick);
    this.element.addEventListener(`click`, this.onLayoutClick);
    this.closeButton.addEventListener(`click`, this.onCloseButtonClick);
    this.confirmButton.addEventListener(`click`, this.onConfirmButtonClick);
  }
}

export {NotificationConfirm};
